import React from "react";
import { useTranslation } from "react-i18next";

import { cn } from "@/lib/utils";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { ButtonVariant, buttonVariants } from "@/components/ui/button";
import { ShortcutBadge } from "@/Utils/keyboardShortcutComponents";

interface ConfirmActionDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: React.ReactNode;
  onConfirm: () => void;
  cancelText?: string;
  confirmText: string;
  variant?: ButtonVariant;
  disabled?: boolean;
  hideCancel?: boolean;
}

export default function ConfirmActionDialog({
  open,
  onOpenChange,
  title,
  description,
  onConfirm,
  cancelText,
  confirmText,
  variant = "primary",
  disabled,
  hideCancel,
}: ConfirmActionDialogProps) {
  const { t } = useTranslation();
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="capitalize">{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          {!hideCancel && (
            <AlertDialogCancel>{cancelText || t("cancel")}</AlertDialogCancel>
          )}
          <AlertDialogAction
            onClick={onConfirm}
            className={cn(buttonVariants({ variant }))}
            disabled={disabled}
          >
            {confirmText}
            <ShortcutBadge actionId="submit-action" />
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
